/** @format */

import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { header } from "../../../../../components/api/Header";
import PieChart4 from "../../../../../components/Charts/PieChart4";
import PieChart5 from "../../../../../components/Charts/PieChart5";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../lib/env";

function Table({ date }) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${getEnv('REACT_APP_BASE_URL')}/v1/republik/zarafshon/table?date=${date}`,
        header()
      );
      setData(res.data);
    } catch (error) {
      console.log("Xato:", error);
    } finally {
      setLoading(false);
    }
  }, [date]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) <LoadingCard loading={loading} heightSize='80vh' />;

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-8'>
          <div className='pie-box' style={{ height: "300px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Zarafshon daryosi balansi</h4>
            </div>

            <table className='table table-striped zarafshon-table mt-3'>
              <thead>
                <tr>
                  <th
                    width='2%'
                    className='text-black vertical-middle'
                    scope='col'>
                    №
                  </th>

                  <th
                    width='23%'
                    className='text-black vertical-middle'
                    scope='col'>
                    Viloyatlar nomi
                  </th>

                  <th
                    width='15%'
                    className='text-black text-center vertical-middle'
                    scope='col'>
                    Tasdiqlangan taqsimot
                  </th>

                  <th
                    width='15%'
                    className='text-black text-center vertical-middle'
                    scope='col'>
                    Taqsimot bo’yicha (m<sup>3</sup>/s)
                  </th>

                  <th
                    width='15%'
                    className='text-black text-center vertical-middle'
                    scope='col'>
                    Amaldagi taqsimot (m<sup>3</sup>/s)
                  </th>

                  <th
                    width='15%'
                    className='text-black text-center vertical-middle'
                    scope='col'>
                    Farqi
                  </th>

                  <th
                    width='15%'
                    className='text-black text-center vertical-middle'
                    scope='col'>
                    Foiz
                  </th>
                </tr>
              </thead>

              {data ? (
                <tbody>
                  <tr>
                    <th scope='row'>
                      <span>1</span>
                    </th>

                    <td>Samarqand</td>

                    <td className='text-center'>70.2%</td>

                    <td className='text-center'>
                      {taqsimotga(data["taqsimotga"], 70.2)}
                    </td>

                    <td className='text-center'>
                      {data["tablega"]["186"]["suvi"]}
                    </td>

                    <td className='text-center'>
                      {farq(
                        data["tablega"]["186"]["suvi"],
                        taqsimotga(data["taqsimotga"], 70.2)
                      )}
                    </td>

                    <td className='text-center'>
                      {foiz(
                        data["tablega"]["186"]["suvi"],
                        taqsimotga(data["taqsimotga"], 70.2)
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>
                      <span>2</span>
                    </th>

                    <td>Jizzax</td>

                    <td className='text-center'>7.4%</td>

                    <td className='text-center'>
                      {taqsimotga(data["taqsimotga"], 7.4)}
                    </td>

                    <td className='text-center'>
                      {data["tablega"]["208"]["suvi"]}
                    </td>

                    <td className='text-center'>
                      {farq(
                        data["tablega"]["208"]["suvi"],
                        taqsimotga(data["taqsimotga"], 7.4)
                      )}
                    </td>

                    <td className='text-center'>
                      {foiz(
                        data["tablega"]["208"]["suvi"],
                        taqsimotga(data["taqsimotga"], 7.4)
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>
                      <span>3</span>
                    </th>

                    <td>Qashqadaryo</td>

                    <td className='text-center'>9.3%</td>

                    <td className='text-center'>
                      {taqsimotga(data["taqsimotga"], 9.3)}
                    </td>

                    <td className='text-center'>
                      {data["tablega"]["209"]["suvi"]}
                    </td>

                    <td className='text-center'>
                      {farq(
                        data["tablega"]["209"]["suvi"],
                        taqsimotga(data["taqsimotga"], 9.3)
                      )}
                    </td>

                    <td className='text-center'>
                      {foiz(
                        data["tablega"]["209"]["suvi"],
                        taqsimotga(data["taqsimotga"], 9.3)
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>
                      <span>4</span>
                    </th>

                    <td>Navoiy</td>

                    <td className='text-center'>13.1%</td>

                    <td className='text-center'>
                      {taqsimotga(data["taqsimotga"], 13.1)}
                    </td>

                    <td className='text-center'>
                      {data["tablega"]["95"]["suvi"]}
                    </td>

                    <td className='text-center'>
                      {farq(
                        data["tablega"]["95"]["suvi"],
                        taqsimotga(data["taqsimotga"], 13.1)
                      )}
                    </td>

                    <td className='text-center'>
                      {foiz(
                        data["tablega"]["95"]["suvi"],
                        taqsimotga(data["taqsimotga"], 13.1)
                      )}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'></th>
                    <td>Jami</td>
                    <td className='text-center'>100%</td>

                    <td className='text-center'>{fix(data["taqsimotga"])}</td>

                    <td className='text-center'>
                      {fix(data["taqsimotboyichajami"])}
                    </td>

                    <td className='text-center'>
                      {farq(data["taqsimotboyichajami"], data["taqsimotga"])}
                    </td>

                    <td className='text-center'>
                      {foiz(
                        fix(data["taqsimotboyichajami"]),
                        fix(data["taqsimotga"])
                      )}
                    </td>
                  </tr>
                </tbody>
              ) : null}
            </table>
          </div>
        </div>

        <div className='col-md-4'>
          <div className='pie-box pie-box-amu' style={{ height: "300px" }}>
            <div className='zarafshon-chart-table'>
              <h4>
                Taqsimot bo’yicha (m<sup>3</sup>/s)
              </h4>
            </div>

            {data ? (
              <PieChart4
                d1={chartga(data["taqsimotga"], 70.2)}
                d2={chartga(data["taqsimotga"], 7.4)}
                d3={chartga(data["taqsimotga"], 9.3)}
                d4={chartga(data["taqsimotga"], 13.1)}
              />
            ) : null}
          </div>
        </div>

        <div className='col-md-8'>
          <div className='pie-box pb-1'>
            <div className='zarafshon-chart-table'>
              <div>
                <h4 className='m-0'>Zarafshon daryosi va Qattaqo’rg’on</h4>
              </div>

              <div>
                <p className='m-0'>
                  Suv omboridan chiqarilgan suvning taqsimoti
                </p>
              </div>
            </div>

            <table className='table table-striped zarafshon-table mt-1'>
              <thead>
                <tr>
                  <th className='text-black' scope='col'>
                    №
                  </th>

                  <th className='text-black' scope='col'>
                    Manbalar
                  </th>

                  <th
                    className='text-center text-black'
                    width={150}
                    scope='col'>
                    Suv sarflari, m<sup>3</sup>/s
                  </th>
                </tr>
              </thead>

              {data ? (
                <tbody>
                  <tr>
                    <th width={10} scope='row'>
                      <span>1</span>
                    </th>

                    <td>Ravotxo’ja g/u</td>

                    <td className='text-center'>
                      {data["tablega"]["212"]["suvi"]}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>
                      <span>2</span>
                    </th>

                    <td>Kattaqo’rg’on suv ombori kirishi</td>

                    <td className='text-center'>
                      {data["tablega"]["244"]["suvi"]}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>
                      <span>3</span>
                    </th>

                    <td>Kattaqo’rg’on suv ombori chiqishi</td>

                    <td className='text-center'>
                      {data["tablega"]["246"]["suvi"]}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>
                      <span>4</span>
                    </th>

                    <td>Oqdaryo SO kelishi</td>

                    <td className='text-center'>
                      {data["tablega"]["241"]["suvi"]}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>
                      <span>5</span>
                    </th>

                    <td>Oqdaryo SO chiqishi</td>

                    <td className='text-center'>
                      {data["tablega"]["243"]["suvi"]}
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'></th>
                    <td>Jami</td>
                    <td className='text-center'>{fix(data["jami"])}</td>
                  </tr>

                  <tr>
                    <th width={10} scope='row'>
                      <span>1</span>
                    </th>

                    <td className='text-left'>Suvning yo'qolishi</td>

                    <td className='text-center'>{fix(data["jami"] * 0.1)}</td>
                  </tr>

                  <tr>
                    <th width={10} scope='row'>
                      <span>2</span>
                    </th>

                    <td className='text-left'>Navoiy GRES</td>

                    <td className='text-center'>
                      {data["tablega"][101]["suvi"]}
                    </td>
                  </tr>

                  <tr>
                    <th width={10} scope='row'>
                      <span>3</span>
                    </th>

                    <td className='text-left'>Taqsimotga</td>
                    <td className='text-center'>{fix(data["taqsimotga"])}</td>
                  </tr>
                </tbody>
              ) : null}
            </table>
          </div>
        </div>

        <div className='col-md-4'>
          <div className='pie-box pie-box-amu' style={{ height: "415px" }}>
            <div className='zarafshon-chart-table'>
              <h4>
                Amalda (m<sup>3</sup>/s)
              </h4>
            </div>

            {data ? (
              <PieChart5
                d1={data["data2"][0]}
                d2={data["data2"][1]}
                d3={data["data2"][2]}
                d4={data["data2"][3]}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Table;

const taqsimotga = (a, b) => {
  if (!a || typeof a === "undefined" || a === 1) {
    a = 1;
    return 0;
  }
  if (!b || typeof b === "undefined" || b === 1) {
    b = 1;
  }
  let s = (a * b) / 100;
  if (s % 1 !== 0) {
    return s.toFixed(2);
  }
  return s;
};

const foiz = (a, b) => {
  if (!a || typeof a === "undefined" || a === 0 || a === "-") {
    a = 0;
  }
  if (!b || typeof b === "undefined" || b === 0 || b === "-") {
    b = 0;
  }
  if (b === 0) return 0;
  let s = (a / b) * 100;
  if (s % 1 !== 0) {
    return s.toFixed(2);
  }
  return s;
};

const farq = (a, b) => {
  if (!a || typeof a === "undefined" || a === 1) {
    a = 0;
  }
  if (!b || typeof b === "undefined" || b === 1) {
    b = 0;
  }
  let s = a - b;
  if (s % 1 !== 0) {
    return s.toFixed(2);
  }
  return s;
};

const chartga = (a, f) => {
  if (!a || typeof a === "undefined" || a === 1) {
    return 0;
  }
  let s = (a / 100) * f;
  if (s % 1 !== 0) {
    return s.toFixed(0);
  }
  return s;
};

const fix = (v) => {
  if (!v || typeof v === "undefined") {
    return "-";
  } else {
    if (v % 1 === 0) {
      return v;
    } else return v.toFixed(2);
  }
};
